import React from 'react';
import cn from 'classnames';

import styles from './Divider.module.scss';

type DividerProps = {
  className?: string;
  component?: string | React.ElementType;
};

const Divider: React.FC<DividerProps> = ({
  className,
  component: Component = 'hr',
}) => {
  return <Component className={cn(styles.divider, className)} />;
};

export default Divider;
